import { MagnifyingGlass } from '@phosphor-icons/react';
import { Link } from 'react-router';
import { EmptyState } from '@/components/empty-state';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="grid min-h-dvh place-items-center p-6">
      <EmptyState
        icon={MagnifyingGlass}
        title="Página não encontrada"
        description="O endereço pode ter mudado ou não existe mais."
        action={
          <Button asChild>
            <Link to="/">Ir para o início</Link>
          </Button>
        }
      />
    </div>
  );
}
